import { userService } from '../services';
import router from '../router';

const state = {
  account: {
    loggedIn: false,
    user: null,
    token: null,
  },
  toUrl: null,
};

const user = JSON.parse(localStorage.getItem('user'));

if (user) {
  state.account = {
    loggedIn: true,
    user,
    token: null,
  };
}

const getters = {
  // fullname(state) {
  //   return `${state.account.user.firstname} ${state.account.user.lastname}`;
  // },
  // getCurrentUser(state) {
  //   return state.account.user.id;
  // },
  profileId: state => state.account.user.curator_id,
};

const actions = {
  async login({ dispatch, commit }, { email, password, role }) {
    dispatch('alert/busy', null, { root: true });
    try {
      const user = await userService.login(email, password, role);
      dispatch('alert/success', 'Login success', { root: true });
      commit('loginSuccess', user);
      if (state.toUrl) {
        const url = state.toUrl;
        commit('clearToUrl');
        router.push(url);
      } else {
        router.push('/dashboard');
      }
    } catch (error) {
      dispatch('alert/error', error, { root: true });
      router.push('/');
    }
  },
  async logout({ dispatch, commit }) {
    try {
      commit('logout');
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
  async register({ dispatch }, data) {
    dispatch('alert/busy', null, { root: true });
    try {
      await userService.register(data);
      dispatch('alert/success', 'Registration success', { root: true });
      router.push('/login');
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
  async updateAccount({ dispatch, commit }, { form, id }) {
    dispatch('alert/busy', null, { root: true });
    try {
      await userService.updateAccount({ form, id });
      dispatch('alert/success', 'Account updated', { root: true });
      commit('editSuccess', form);
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
  async resetPassword({ dispatch }, form) {
    dispatch('alert/busy', null, { root: true });
    try {
      await userService.resetPassword(form);
      dispatch('alert/success', 'Password reset', { root: true });
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
  async deleteAccount({ dispatch, commit }) {
    dispatch('alert/busy', null, { root: true });
    try {
      await userService.deleteAccount();
      dispatch('alert/success', 'Account removed', { root: true });
      commit('logout');
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
};

const mutations = {
  loginSuccess(state, user) {
    state.account.loggedIn = true;
    localStorage.setItem('user', JSON.stringify(user));
    state.account.user = user;
  },
  logout(state) {
    state.account.user = null;
    state.account.loggedIn = false;
    localStorage.removeItem('user');
    router.push('/');
  },
  editSuccess(state, user) {
    state.account.user = {
      ...state.account.user,
      ...user,
    };
    // localStorage.setItem('user', JSON.stringify(user));
  },
  setToUrl(state, url) {
    state.toUrl = url;
  },
  clearToUrl(state) {
    state.toUrl = null;
  },
};

export const account = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/account.module.js